import { generateClient } from 'aws-amplify/api';
import { withPromiseTimeout } from '@codexporer.io/promise-timeout';

const client = generateClient();

export const graphql = operation => withPromiseTimeout(client.graphql(operation));
